import { Grid } from "@mui/material";
import AutoCompleteRedux from "components/molecules/AutoCompleteRedux";
import CheckboxRedux from "components/molecules/CheckboxRedux";
import DateTimePickerRedux from "components/molecules/DateTimePickerRedux";
import InputRedux from "components/molecules/InputRedux";
import SelectZoneClass from "pages/AddBooking/SelectZoneClass";
import { change, Field } from "redux-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  date,
  lessThan100,
  number,
  required,
} from "utils/validate.util";
import Calculations from "./Calculations";
import { useEffect } from "react";

const BookingForm = ({ index, member }: { index: number; member: string }) => {
  const form = 'AddQuotationForm';
  const dispatch = useAppDispatch();

  const { hourly, destination } = useAppSelector(
    (state) => state.form?.[form]?.values?.bookings[index]
  );

  useEffect(() => {
    if (hourly) dispatch(change(form, `${member}.destination`, destination?.value || destination));
  }, [destination, dispatch, member, hourly])

  
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Field
            name={member + ".hourly"}
            label={"Hourly"}
            component={CheckboxRedux}
          />
        </Grid>
        <Grid item md={4}>
          <Field
            name={`${member}.start_date`}
            label={"Date & Time"}
            validate={[date]}
            component={DateTimePickerRedux}

          />
        </Grid>
        {/* {!hourly && (
          <Grid item md={4}>
            <Field
              name={member + ".end_date"}
              label={"End Date"}
              component={DateTimePickerRedux}
            />
          </Grid>
        )} */}

        <Grid item md={4}>
          <Field
            name={member + ".pickup"}
            label={"Pickup"}
            // validate={[requiredAutoComplete]}

            component={AutoCompleteRedux}

          />
        </Grid>

        {!hourly ? (
          <Grid item md={4}>
            <Field
              name={member + ".destination"}
              label={"Destination"}
              //   validate={[AutoCom]}
              component={AutoCompleteRedux}
            />
          </Grid>
        ) : (
          <>
            <Grid item md={4}>
              {" "}
              <Field
                name={member + ".destination"}
                label={"Destination"}

                //   validate={[AutoCom]}
                component={InputRedux}
              />{" "}
            </Grid>
            <Grid item md={4}>
              {" "}
              <Field
                name={member + ".duration"}
                label={"Duration"}
                validate={[number, required]}
                component={InputRedux}
                InputProps={{ InputProps: { endAdornment: `Hours` } }}
              />{" "}
            </Grid>
          </>
        )}

        <Grid item md={4}>
          <Field
            name={member + ".class_id"}
            label={"Class"}
            validate={[required]}
            component={SelectZoneClass}
          />
        </Grid>
        <Grid item md={4}>
          <Field
            name={member + ".passengers"}
            label={"Passengers"}
            validate={[number]}
            component={InputRedux}
          />
        </Grid>
        <Grid item md={4}>
          <Field
            name={member + ".quantity"}
            label={"Quantity"}
            validate={[number, lessThan100]}
            component={InputRedux}
          />
        </Grid>
        {hourly && (
          <Grid item md={4}>
            <Field
              name={member + ".per_hour"}
              label={"Per hour"}
              validate={[number]}
              component={InputRedux}
              InputProps={{ InputProps: { endAdornment: `SAR` } }}
            />
          </Grid>
        )}
        {!hourly && (
          <Grid item md={4}>
            <Field
              name={member + ".distance"}
              label={"Distance"}
              component={InputRedux}
              InputProps={{ InputProps: { endAdornment: `KM`, disabled: true } }}
            />
          </Grid>
        )}
        {!hourly && (
          <Grid item md={4}>
            <Field
              name={member + ".base_price"}
              label={"Base Price"}
              validate={[number]}
              component={InputRedux}
              InputProps={{ InputProps: { endAdornment: `SAR` } }}
            />
          </Grid>
        )}

        <Grid item md={4}>
          <Field
            name={member + ".net_price"}
            label={"Net Price"}
            validate={[number]}
            component={InputRedux}
            InputProps={{ InputProps: { endAdornment: `SAR`,disabled: true } }}
          />
        </Grid>

        <Grid item md={4}>
          <Field
            name={member + ".tax"}
            label={"Tax"}
            validate={[number,required]}
            component={InputRedux}
            InputProps={{ InputProps: { endAdornment: `%` } }}
          />
        </Grid>
        <Grid item md={4}>
          <Field
            name={member + ".gross_price"}
            label={"Gross Price"}
            validate={[number]}
            component={InputRedux}
            InputProps={{ InputProps: { endAdornment: `SAR`, disabled: true } }}
          />
        </Grid>
      </Grid>
      <Calculations index={index} member={member} />
    </div>
  );
};

export default BookingForm;
